import * as React from 'react';
import clsx from 'clsx';

import useStyles from './styles';

const FaqContent = ({ hidden = false }) => {
  const classes = useStyles();
  return (
    <div
      className={clsx({
        [classes.faqContent]: !hidden,
        [classes.faqInContent]: hidden,
      })}
    >
      <div>
        <div className={classes.question}>
          1. Why use AI-generated video scripts for sales?
        </div>
        <div className={classes.answer}>
          Creating personalized and engaging sales videos can be a daunting
          task, but with the help of AI-generated scripts, the process becomes
          much more efficient. The AI algorithms are able to analyze customer
          data and craft scripts tailored to the specific needs and interests of
          the target audience. This makes it more likely that the video will
          connect with viewers and ultimately lead to increased sales. Not only
          that, but using AI-generated scripts can save time and resources
          compared to manually writing them, allowing sales teams to focus on
          other important tasks.
        </div>
      </div>
      <div>
        <div className={classes.question}>
          2. How do you script a sales video?
        </div>
        <div className={classes.answer}>
          To script your sales videos, simply answer the prompts on this page,
          and then let AI do the hard work for you!
        </div>
      </div>
      <div>
        <div className={classes.question}>
          3. What should a video script include?
        </div>
        <div className={classes.answer}>
          Creating a successful sales video requires a lot of thought and
          planning. One of the most important elements is the script. In order
          to be effective, a video script for sales should have several key
          components.
          <br />
          <br />
          Firstly, your introduction needs to grab the viewer's attention. This
          can be done by starting with an interesting fact, posing a question,
          or making a statement that will make people want to keep watching.
          <br />
          <br />
          Once you have their attention, you need to clearly state the problem
          or pain point that your product or service addresses, and then explain
          how it can help solve that problem.
          <br />
          <br />
          The next step is to demonstrate what your product or service is, and
          how it works. Use visual aids and examples to make it as clear as
          possible.
          <br />
          <br />
          At the end of the video, you should have a strong call-to-action. Tell
          the viewer exactly what you want them to do next, whether it's
          visiting your website, calling a phone number, or making a purchase.
          <br />
          <br />
          Creating a sense of urgency can also be effective by highlighting a
          limited-time offer or special promotion that the viewer should take
          advantage of right away.
          <br />
          <br />
          Lastly, make sure to include your company's logo and branding
          throughout the video to help build brand awareness.
        </div>
      </div>
      <div>
        <div className={classes.question}>4. Do scripts work in sales?</div>
        <div className={classes.answer}>
          Scripts can be an effective tool in sales as they help salespeople to
          stay on message and ensure that key points are communicated clearly
          and consistently.
          <br />
          <br />
          However, it's important to note that while scripts can be useful, they
          are not a one-size-fits-all solution.
          <br />
          <br />
          Our goal with this AI Script Generator is to help you quickly and
          easily tailor your message to specific situations… but still, these
          are just starting points.
          <br />
          <br />
          Customize the words and take these scripts to the next level!
        </div>
      </div>
      <div>
        <div className={classes.question}>
          5. How to generate a sales video script using AI?
        </div>
        <div className={classes.answer}>
          Sendspark’s AI-Powered Video Script Generator is made for instantly
          generating personalized sales video scripts. Try it out here!
        </div>
      </div>
      <div>
        <div className={classes.question}>
          6. Can AI make video scripts for sales?
        </div>
        <div className={classes.answer}>
          Well, there’s only one way to find out! Try our tool here to get
          started.
        </div>
      </div>
    </div>
  );
};

export default FaqContent;
